import { SVGAttributes } from "react";

export const NotificationIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={17}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.556c0-.491.398-.89.889-.89.437 0 .698-.114.88-.26.196-.159.376-.42.533-.832.28-.74.398-1.7.537-2.834.025-.205.05-.415.078-.63.168-1.317.405-2.829 1.106-4.009.364-.61.86-1.15 1.54-1.53C6.243.192 7.053 0 8 0c.948 0 1.758.192 2.437.571.68.38 1.176.92 1.54 1.53.701 1.18.938 2.692 1.106 4.009.028.215.053.425.078.63.14 1.133.257 2.094.537 2.834.157.413.338.673.534.832.18.146.442.26.88.26a.889.889 0 110 1.778H.888A.889.889 0 010 11.556zm12.036-1.352c.06.156.126.311.202.463H3.762a4.93 4.93 0 00.202-.463c.364-.96.511-2.18.646-3.298l.07-.571c.173-1.35.384-2.505.871-3.325.232-.39.516-.684.88-.887.365-.204.864-.345 1.569-.345s1.204.141 1.57.345c.363.203.647.498.879.887.487.82.698 1.974.87 3.325.024.186.047.377.07.571.136 1.117.283 2.338.647 3.298zm-6.27 4.825a2.985 2.985 0 01-.544-1.696h2c0 .137.05.363.167.527a.533.533 0 00.192.168.9.9 0 00.419.083.9.9 0 00.42-.083.533.533 0 00.19-.168.99.99 0 00.168-.527h2c0 .457-.129 1.119-.544 1.696-.452.628-1.197 1.082-2.234 1.082s-1.782-.454-2.234-1.082z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 16a1 1 0 011-1c.492 0 .785-.129.99-.293.22-.179.423-.472.6-.937.315-.831.447-1.912.603-3.188l.088-.709c.19-1.48.456-3.182 1.245-4.51.409-.686.967-1.293 1.733-1.72C10.023 3.216 10.934 3 12 3s1.977.216 2.741.643c.766.427 1.324 1.034 1.733 1.72.79 1.328 1.056 3.03 1.244 4.51l.088.709c.157 1.276.29 2.357.605 3.188.176.465.379.758.6.937.204.164.497.293.989.293a1 1 0 110 2H4a1 1 0 01-1-1zm13.54-1.52c.067.175.142.35.228.52H7.232c.086-.17.16-.345.227-.52.41-1.08.576-2.454.727-3.71l.08-.643c.193-1.52.43-2.818.98-3.74.26-.439.579-.77.988-.998C10.645 5.159 11.207 5 12 5s1.355.159 1.766.389c.409.228.729.56.989.997.548.923.786 2.221.98 3.74l.079.642v.001c.151 1.257.317 2.63.727 3.71zm-6.952 5.354A3.233 3.233 0 019 18h2c0 .173.06.456.211.666.115.159.315.334.789.334.474 0 .674-.175.789-.334.15-.21.211-.493.211-.666h2c0 .493-.14 1.211-.588 1.834C13.925 20.51 13.126 21 12 21s-1.926-.491-2.412-1.166z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
NotificationIcon.displayName = "NotificationIcon";
